import SFAuthService, { NO_USER } from '../SFAuthService'
import { FORM_PREVIEW_CONFIG } from './sfForms'

export const PORTAL_TRANSLATION_CONFIGURATION = 'PORTAL_TRANSLATION_CONFIGURATION'

export const savePortalTranslationConfig = config => {
  const conn = SFAuthService.getConnection()
  if (!conn) {
    return Promise.reject(NO_USER)
  }
  return conn
    .sobject('Configuration__c')
    .find({ Name: PORTAL_TRANSLATION_CONFIGURATION })
    .then(result => {
      if (result.length > 0) {
        const id = result[0].Id
        return conn.sobject('Configuration__c').update({
          Id: id,
          Value__c: JSON.stringify(config)
        })
      } else {
        return conn.sobject('Configuration__c').create({
          Name: PORTAL_TRANSLATION_CONFIGURATION,
          Value__c: JSON.stringify(config)
        })
      }
    })
}

export const getPortalTranslationConfig = () => {
  const conn = SFAuthService.getConnection()
  if (!conn) {
    return Promise.reject(NO_USER)
  }
  return conn
    .sobject('Configuration__c')
    .find({ Name: PORTAL_TRANSLATION_CONFIGURATION })
    .then(result => {
      if (result.length > 0) {
        return JSON.parse(result[0].Value__c)
      } else {
        return {}
      }
    }
    )
}
